import { setHeightScrollBar } from './Maps.js';
/*
    Кастомный скроллбар
*/

/*if (!App.mobile) {*/
    $('.js-scroll')
        .addClass('scrollbar-inner')
        .scrollbar({
            /*ignoreMobile: true*/
        });

    setHeightScrollBar();
/*}*/



// WEBPACK FOOTER //
// ./_src/js/modules/Scroll.js